import { render, staticRenderFns } from "./Alphabet.vue?vue&type=template&id=7d1c6c62&scoped=true"
import script from "./Alphabet.vue?vue&type=script&lang=js"
export * from "./Alphabet.vue?vue&type=script&lang=js"
import style0 from "./Alphabet.vue?vue&type=style&index=0&id=7d1c6c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1c6c62",
  null
  
)

export default component.exports